"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// A utility method for extracting properties meant for boxes
// see DateInput's underlying input component
var boxPropNames = ['margin', 'm', 'mr', 'ml', 'mt', 'mb', 'width', 'height', 'my', 'mx'];

var _default = function _default(props) {
  var boxProps = {};
  var rest = {};

  for (var propName in props) {
    var v = props[propName];

    if (boxPropNames.indexOf(propName) !== -1) {
      boxProps[propName] = v;
    } else {
      rest[propName] = v;
    }
  }

  return [boxProps, rest];
};

exports["default"] = _default;